const Header = ({data}) => {
    let title = data?.title?.rendered || "Kumar Desai";
    let subtitle = data?.acf?.sub_title || "Web Developer";
    let description = data?.acf?.description || "Full-Stack<span></span>Front-End Engineer";

    return (
        <header id="header">
            <video id="background-video" playsinline autoPlay muted>
                <source src="/assets/images/sample-video-2.mp4" type="video/mp4" />
            </video>
            <div className="content-area">
                <div className="welcome">
                    <img src="/assets/images/line.png" alt="line" className="line" />
                    <h3>Welcome</h3>
                    <img src="/assets/images/line.png" alt="line" className="line" />
                </div>
                <p className="my-name">{title}<span>{subtitle}</span></p>
                <p className="my-description" dangerouslySetInnerHTML={{ __html: description }}></p>
                <div className="down-pointer">
                    <span><i className="fa-solid fa-angle-down" aria-hidden="true"></i></span>
                </div>
            </div>
        </header>
    );
}

export default Header;